module.exports = __webpack_public_path__ + "static/media/galerija_2014 (25).017bd7af.jpg";